<template>
  <div v-if="code || billNumber" class="warranty-code-header">
    <div v-if="code" class="d-flex align-items-center mb-2">
      <span>
        <i class="fa fa-receipt text-warning mr-2" style="font-size: 1.3rem"></i> Mã phiếu:
         <span class="font-weight-bold">{{ code }} <small v-if="createdAt" class="text-muted">| Ngày tạo: {{ createdAt }}</small> </span><br/>
      </span>
    </div>
    <div v-if="billNumber" class="d-flex align-items-center">
      <i class="fas fa-link text-info mr-2" style="font-size: 1rem"></i>
      <span>
        Từ hoá đơn:
        <span
          class="text-danger font-weight-bold"
          :style="{ cursor: onBillClick ? 'pointer' : 'default' }"
          @click="linkToBill(billNumber)"
          >#{{ billNumber }}</span
        >
      </span>
    </div>
    <div v-if="previousStoreName" class="d-flex align-items-center">
      <i class="fas fa-exchange-alt text-info mr-2" style="font-size: 1rem"></i>
      <span>
        Chuyển từ:
        <span
          class="text-danger font-weight-bold"
          >{{ previousStoreName }}</span
        >
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WarrantyCodeHeader',
  props: {
    code: {
      type: String,
      default: null,
    },
    billNumber: {
      type: [String, Number],
      default: null,
    },
    onBillClick: {
      type: Function,
      default: null,
    },
    createdAt: {
      type: String,
      default: null,
    },
    previousStoreName: {
      type: String,
      default: null,
    },
  },
  methods: {
    linkToBill(billNumber) {
      this.$router.push({
        name: 'update-bill',
        query: { id: billNumber },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.warranty-code-header {
  display: flex;
  flex-direction: column;
  padding: 0.75rem 1.25rem;
  border: 1px solid #ffeeba;
  border-radius: 0.375rem;
  color: #212121;
  background-color: #fffbe6;
  font-size: 1.125rem;
  font-weight: 600;
}
</style>
